import { render, staticRenderFns } from "./OdpCreditHistoryModal.vue?vue&type=template&id=39d8562b"
import script from "./OdpCreditHistoryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OdpCreditHistoryModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports